// extracted by mini-css-extract-plugin
export var currentStep = "_ix-2";
export var nodeCard = "_ix-0";
export var pathHighlighted = "_ix-1";